import styled from '@emotion/styled';
import React, { FC } from 'react';
import { color } from 'src/shared/styles/variables';

interface ProgressBarProps {
    progressPercentage: number;
}

const ProgressBarRail = styled('div')({
    width: '100%',
    height: 8,
    backgroundColor: color.whiteLilac,
    position: 'relative',
    borderRadius: 18,
});

const ProgressBarTrack = styled('div')<Pick<ProgressBarProps, 'progressPercentage'>>(
    ({ progressPercentage }) => ({
        width: `${progressPercentage}%`,
        height: '100%',
        top: 0,
        left: 0,
        backgroundColor: color.royalBlue,
        transition: 'all 0.5s ease-in-out',
        borderRadius: 18,
    }),
);

export enum ProgramProgressBarTestID {
    Container = 'ProgressBarTestID.Container',
    Bar = 'ProgressBarTestID.Bar',
}

export const ProgressBar: FC<ProgressBarProps> = ({ progressPercentage }) => {
    return (
        <ProgressBarRail data-testid={ProgramProgressBarTestID.Container}>
            <ProgressBarTrack
                data-testid={ProgramProgressBarTestID.Bar}
                progressPercentage={progressPercentage}
            />
        </ProgressBarRail>
    );
};
